import styled from 'styled-components';

export const WinnerCardContainer = styled.div`
	cursor: pointer;
	position: relative;
	outline: none;
	display: grid;
	scroll-snap-align: start;
	height: 100%;
	border-radius: 12px;
	background-color: rgba(var(--gameCardWinnerBg), 1);
`;

export const CardImageContainer = styled.div`
	--borderRadius: 12px;
	width: ${({ containerWidth }) => containerWidth};
	min-height: 104px;
	border-radius: var(--borderRadius) 0 0 var(--borderRadius);
	overflow: hidden;
`;

export const WinnerInfoContainer = styled.div`
	--borderRadius: 12px;
	flex: 1;
	padding: 12px;
	overflow: hidden;
	border-radius: 0 var(--borderRadius) var(--borderRadius) 0 !important;

	p {
		color: rgba(var(--gameCardTitleSmall), 1);
		font: var(--caption);
		overflow: hidden;
		font-weight: 400;
		font-size: 12px;
		line-height: 16px;
	}

	h3 {
		color: rgba(var(--gameCardTitleDetailColor), 1);
		font: var(--gameCardTitleDetailFont);
		overflow: hidden;
		font-weight: 600;
		font-size: 15px;
		line-height: 20px;
		margin-top: 9px;
		span:not(:first-child) {
			padding: 0 0 0 5px;
		}
	}
`;
